import React from "react";
import { ComponentDetailsByFileOut } from "api-client";
import {
  FIELDSSET_TITLE_CLASSES,
  FIELD_LABEL_CLASSES,
  FIELD_VALUE_CLASSES,
} from "features/MappingEditor/consts";
import { useMappingTools } from "features/MappingEditor/useMappingTools";
import Tooltip from "components/Tooltip";
import { useTranslation } from "react-i18next";

const CircularityInformation = ({
  details,
}: {
  details: ComponentDetailsByFileOut | undefined;
}) => {
  const { productCircularityInfo } = useMappingTools();
  const { t } = useTranslation();

  if (details?.type === "COMPONENT") return;
  return (
    <div className="w-full pt-4 border-b border-gray-200">
      <div className={FIELDSSET_TITLE_CLASSES}>
        {t("productEditor.circularity")}
      </div>
      <div className="flex flex-wrap justify-start">
        {productCircularityInfo(details).map((rec, index) => (
          <div key={index} className="pr-4 last-of-type:pr-0">
            <div className={FIELD_LABEL_CLASSES}>{rec.label}</div>
            <div className={FIELD_VALUE_CLASSES}>
              <span>{rec.value || "-"}</span>
              {rec.value && (
                <Tooltip
                  content={`${t("productEditor.score")}: ${rec.score}`}
                  className="text-gray-500"
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CircularityInformation;
